import { ButtonProps, IconButton, Tooltip } from '@chakra-ui/react';
import { ReactElement, useState } from 'react';
import { Icons } from '../Icons';

export const VerifyIconButton = ({
  onVerified,
  icon,
  tooltipLabel,
  buttonProps,
  onVerifyButtonProps = {
    color: 'white',
    backgroundColor: 'red.700',
    borderColor: 'transparent',
    _light: {
      color: 'texas.danger.200 !important',
      backgroundColor: 'texas.danger.50 !important',
      borderColor: 'transparent',
    },
  },
}: {
  onVerified: () => void;
  icon: ReactElement;
  tooltipLabel?: string;
  buttonProps?: ButtonProps;
  onVerifyButtonProps?: ButtonProps;
}) => {
  const [verify, setVerify] = useState(false);

  return (
    <Tooltip label={tooltipLabel}>
      <IconButton
        {...buttonProps}
        icon={verify ? <Icons.Checkmark /> : icon}
        aria-label={tooltipLabel ?? ''}
        _hover={verify ? { ...onVerifyButtonProps } : undefined}
        onBlur={() => {
          setVerify(false);
        }}
        onClick={() => {
          if (verify) {
            onVerified();
            setVerify(false);
            return;
          }
          setVerify(true);
        }}
      />
    </Tooltip>
  );
};
